import { render } from "./ModalCarousel.vue?vue&type=template&id=e6a9fc00&ts=true"
import script from "./ModalCarousel.vue?vue&type=script&lang=ts"
export * from "./ModalCarousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__